import queryString from "query-string";

export const FLAGS = {
    downloadCommunications: "downloadCommunications"
};

export function featureIsActive(feature) {
    // Read query parameters from URL hash as we are using Hash History in react-router
    // https://github.com/reactjs/react-router/blob/master/docs/guides/Histories.md#hashhistory
    const params = queryString.parse(location.hash.substring(location.hash.indexOf("?")));
    let features = [];

    if (params.ff) {
        features = features.concat(params.ff.split(","));
    }

    return features.includes(feature)
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/featureFlags.js
 **/